import { useEffect, useState } from 'react';
// Session-free client: a stale login token in localStorage must never poison
// public reads (the careers/survey "empty page" bug class).
import { publicSupabase as supabase } from '../lib/supabase';
import Hero from '../components/home/Hero';
import FeaturedMenu from '../components/home/FeaturedMenu';
import Founders from '../components/home/Founders';
import BranchesAndValues from '../components/home/BranchesAndValues';

// Following the redesign blueprint: the hero, the menu paired with our
// story, the founders, then branches paired with the values. Everything below the
// hero is real data — featured dishes and branches come from the same tables
// the Menu and Branches pages read, so the home page can never advertise a
// dish or a branch that no longer exists.

export default function Home() {
  const [items, setItems] = useState([]);
  const [branches, setBranches] = useState([]);
  const [branchCount, setBranchCount] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const [menuRes, branchRes] = await Promise.all([
        supabase
          .from('website_menu_items')
          .select('id, name_en, name_id, name_ar, name_ms, description_en, description_id, description_ar, description_ms, price_display, price_min, price_max, image_url, thumbnail_url, is_featured, sort_order')
          .eq('is_active', true)
          .order('is_featured', { ascending: false })
          .order('sort_order')
          .limit(4),
        supabase
          .from('website_branches')
          .select('id, name, slug, address, city, featured_image_url, open_hours, is_featured, sort_order')
          .eq('is_active', true)
          .order('is_featured', { ascending: false })
          .order('sort_order'),
      ]);

      if (menuRes.error) console.error('Home menu fetch:', menuRes.error);
      if (branchRes.error) console.error('Home branches fetch:', branchRes.error);

      setItems(menuRes.data || []);
      const allBranches = branchRes.data || [];
      // Only 6 of 21 branches have a photograph; lead with those so the rail
      // does not open on a row of placeholders.
      const withPhoto = allBranches.filter((b) => b.featured_image_url);
      const without = allBranches.filter((b) => !b.featured_image_url);
      setBranches([...withPhoto, ...without].slice(0, 8));
      setBranchCount(allBranches.length || null);
      setLoading(false);
    })();
  }, []);

  return (
    <div className="overflow-hidden bg-white">
      <Hero />
      <FeaturedMenu items={items} branchCount={branchCount} loading={loading} />
      <Founders />
      <BranchesAndValues branches={branches} loading={loading} />
    </div>
  );
}
